module.exports = __webpack_public_path__ + "static/media/social-instagram.25202c26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-instagram.svg
// module id = 92
// module chunks = 0